module.exports = __webpack_public_path__ + "static/media/mill-healthy.916682cd.svg";